import { actionTypes, } from '../constants';
export const initialState = {
    extension: null,
    list: [],
};
export const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_EXTENSION:
            return setExtension(state, payload);
        case actionTypes.CLEAR_EXTENSION:
            return clearExtension(state);
        case actionTypes.SET_ALL_EXTENSIONS_LIST:
            return setAllExtensionsList(state, payload);
        default:
            return state;
    }
};
function setExtension(state, payload) {
    return {
        ...state,
        extension: payload,
    };
}
function clearExtension(state) {
    return {
        ...state,
        extension: null,
    };
}
function setAllExtensionsList(state, payload) {
    return {
        ...state,
        list: payload,
    };
}
export default reducer;
